import actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {};

const dismissFeatures = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.DISMISS_NEW_FEATURES:
      return {
        ...payload,
      };
    default:
      return state;
  }
};

export default dismissFeatures;
